// import { ElNotification as Notify } from 'element-plus'
import Notify from '@/components/notification'

/**
 * @description Các loại thông báo được hỗ trợ
 */
const enum NOTIFY_TYPES {
  Default = '',
  Success = 'success',
  Warning = 'warning',
  Info = 'info',
  Error = 'error',
}

/**
 * @description Các vị trí hiển thị thông báo
 */
const enum POSITION {
  TOP_RIGHT = 'top-right',
  TOP_LEFT = 'top-left',
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM_LEFT = 'bottom-left',
  TOP_CENTER = 'top-center',
  BOTTOM_CENTER = 'bottom-center',
}

/**
 * @description Option khi sử dụng notify
 */
interface NotifyOptions {
  title?: string
  message?: string
  type?: NOTIFY_TYPES
  customClass?: string
  dangerouslyUseHTMLString?: boolean
  duration?: number
  iconClass?: string
  id?: string
  zIndex?: number
  onClose?: () => void
  onClick?: () => void
  offset?: number
  position?: POSITION | POSITION.TOP_CENTER
  showClose?: boolean
  closeAfterClick?: boolean
}

const defaultOptions = {
  title: 'EMIS Homework',
  message: '',
  type: NOTIFY_TYPES.Default,
  customClass: '',
  dangerouslyUseHTMLString: false,
  duration: 0,
  iconClass: '',
  id: '',
  zIndex: 0,
  onClose: () => {},
  onClick: () => {},
  offset: 0,
  position: POSITION.TOP_CENTER,
  showClose: true,
  closeAfterClick: false
}

const getOptions = (
  options: NotifyOptions,
  notifyType: NOTIFY_TYPES = NOTIFY_TYPES.Default
) => {
  return { ...defaultOptions, ...options, type: notifyType }
}

const showNotify = function (
  options: NotifyOptions,
  notifyType: NOTIFY_TYPES = NOTIFY_TYPES.Default
) {
  options = getOptions(options, notifyType)
  Notify(options)
}

class MNotify {
  private defaultOptions: NotifyOptions

  constructor () {
    this.defaultOptions = {
      title: 'EMIS Homework',
      message: '',
      type: NOTIFY_TYPES.Default,
      customClass: '',
      dangerouslyUseHTMLString: false,
      duration: 0,
      iconClass: '',
      id: '',
      zIndex: 0,
      onClose: () => {},
      onClick: () => {},
      offset: 0,
      position: POSITION.TOP_CENTER,
      showClose: true,
      closeAfterClick: false
    }
  }

  /**
   * @description Hiển thị notify success
   * @param options
   */
  showSuccess (options: NotifyOptions) {
    const successOptions = {
      ...options,
      duration: 4000
    }

    showNotify(successOptions, NOTIFY_TYPES.Success)
  }

  /**
   *
   * @param options
   */
  showWarning (options: NotifyOptions) {
    showNotify(options, NOTIFY_TYPES.Warning)
  }

  /**
   *
   * @param options
   */
  showInfo (options: NotifyOptions) {
    showNotify(options, NOTIFY_TYPES.Info)
  }

  /**
   *
   * @param options
   */
  showError (options: NotifyOptions) {
    showNotify(options, NOTIFY_TYPES.Error)
  }

  /**
   *
   * @param options
   */
  showCustomNotify (options: NotifyOptions) {
    showNotify(options, NOTIFY_TYPES.Default)
  }
}

export default new MNotify()
export { NOTIFY_TYPES, POSITION }
